<template>
  <v-card>
    <v-card-title>
      <v-row no-gutters>
        <span class="mt-2"> Timesheet Report</span>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="3" sm="4">
          <DateRangeInputField
            v-model="selectedDateRange"
            label="Report Date Range"
            first-day-of-week="1"
            hide-actions
            placeholder="Select Report Date Range"
            prepend-icon=""
          />
        </v-col>
        <v-col cols="12" md="1" sm="1" class="mt-9">
          <v-menu offset-y left attach>
            <template v-slot:activator="{ props }">
              <v-btn small icon light v-bind="props">
                <v-icon icon cir> mdi-menu-down </v-icon>
              </v-btn>
            </template>
            <v-list flat class="pa-6">
              Options
              <v-list-item v-for="item in dateRanges" :key="item" :value="item" :title="item" @click="selectedRange(item)" />
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="12" md="3" sm="4">
          <SelectField
            class="action-field"
            :items="projectLeads"
            item-title="text"
            item-value="id"
            v-model="selectedProjectLead"
            label="Project Lead"
            placeholder="Project Lead"
            dense
            outlined
          />
        </v-col>
        <v-col cols="12" v-if="selectedProjectLead" md="3" sm="4">
          <SelectField
            class="action-field"
            :items="teammembers"
            item-title="text"
            multiple
            item-value="id"
            v-model="selectedTeammembers"
            label="Teammembers"
            plcaholder="Teammembers"
            dense
            outlined
          />
        </v-col>
        <v-col md="2" sm="4" cols="12">
          <v-btn class="accent action-button mt-9" color="primary" :loading="isLoading" @click="createReport">
            <v-icon>mdi-sync</v-icon> Process
          </v-btn>
        </v-col>
      </v-row>
      <v-divider class="mt-5"></v-divider>
      <br />
    </v-card-text>
    <v-card-text class="report-content">
      <div v-if="showReport">
        <v-row>
          <v-col md="4" sm="4" cols="12" @click="git.connectionErrorDialogVisible = true" v-if="git.connectionErrors.length">
            <v-alert border="right" colored-border type="error" elevation="2"> Git Connection Errors ({{ git.connectionErrors.length }})</v-alert>
          </v-col>
          <v-col md="3" sm="3" cols="12">
            <v-alert border="right" colored-border type="success" elevation="2"> Total Hours: {{ removeDecimals(this.grandTotalBillable) }} </v-alert>
          </v-col>
          <v-col md="5" sm="5" cols="12">
            <v-alert border="right" colored-border type="success" elevation="2">
              <span>Total Lines Added ({{ commit.totalAdded }})/ Modified ({{ commit.totalModified }})/ Deleted ({{ commit.totalDeleted }})</span>
            </v-alert>
          </v-col>
        </v-row>
        <v-divider class="mt-5"></v-divider>
        <br />
        <v-row v-if="timesheet.issues.length">
          <v-col
            md="4"
            sm="4"
            cols="12"
            v-for="teammemberTimesheetIssue in timesheet.issues"
            :key="`${teammemberTimesheetIssue.teammemberId}`"
            @click="
              showTimesheetIssuesForTeammember(
                teammemberTimesheetIssue.teammemberId,
                teammemberTimesheetIssue.teammemberName,
                teammemberTimesheetIssue.issues
              )
            "
          >
            <v-alert border="right" colored-border type="warning" elevation="2">
              Timesheet issue for {{ teammemberTimesheetIssue.teammemberName }} ({{ teammemberTimesheetIssue.issues.length }})</v-alert
            >
          </v-col>
        </v-row>
        <v-divider class="mt-5"></v-divider>
        <br />
        <v-col class="mb-3" md="12" sm="12" cols="12">
          <v-row>
            <v-col md="2" sm="2" cols="12">
              <v-btn class="secondary action-button" :loading="isLoading" @click="sendEmail"
                ><v-icon class="mr-2">mdi-send-outline</v-icon> Send
              </v-btn>
            </v-col>
            <v-col md="3" sm="3" cols="12">
              <v-btn class="secondary action-button" :loading="isLoading" @click="download">
                <v-icon>mdi-download-outline</v-icon> Download Report
              </v-btn>
            </v-col>
            <v-col md="3" sm="3" cols="12" v-if="isAdmin">
              <v-btn class="accent action-button" :loading="isLoading" @click="syncAllRepositories">
                <v-icon x-small>mdi-sync</v-icon> Sync Repositories
              </v-btn>
            </v-col>
            <v-col md="3" sm="3" cols="12">
              <v-btn class="accent action-button" :loading="isLoading" @click="syncCommitsForSelectedTeamMembers">
                <v-icon x-small>mdi-sync</v-icon> Sync Commits
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <div>
          <v-col md="12" sm="12" cols="12" v-for="(listItem, index) in teammemberReport" :key="'row_' + index">
            <v-row class="mb-10 timesheetreport-body" v-for="(weekItems, weekIndex) in listItem.weeklyReport" :key="'week_' + weekIndex">
              <v-col class="header mb-1 timesheetreport-item" md="12" sm="12" cols="12">
                <v-row>
                  <v-col md="9" sm="9" cols="9">
                    <h3>Timesheet Report Week {{ weekItems.week }}</h3>
                  </v-col>
                  <v-col md="3" sm="3" cols="3" class="text-right">
                    <h3>
                      {{ listItem.teammemberName }}
                    </h3>
                  </v-col>
                </v-row>
              </v-col>
              <v-col md="12" sm="12" cols="12" class="timesheetreport-item">
                <v-row>
                  <v-col xl="1" md="1" cols="1" sm="1" class="text-center titles">
                    <strong>Date</strong>
                  </v-col>
                  <v-col md="1" cols="1" sm="1" class="text-center titles">
                    <strong>IssueNo</strong>
                  </v-col>
                  <v-col md="2" cols="2" sm="2" class="text-center titles">
                    <strong>Project</strong>
                  </v-col>
                  <v-col md="1" cols="1" sm="1" class="text-center titles">
                    <strong>Epic</strong>
                  </v-col>
                  <v-col md="1" cols="1" sm="1" class="text-center titles">
                    <strong>Activity</strong>
                  </v-col>
                  <v-col xl="2" md="2" cols="2" sm="2" class="text-center titles">
                    <strong>Technology</strong>
                  </v-col>
                  <v-col md="1" cols="1" sm="1" class="text-center titles">
                    <strong>Effort</strong>
                  </v-col>
                  <v-col md="2" cols="2" sm="2" class="text-center titles">
                    <strong>Adjustment</strong>
                  </v-col>
                  <v-col md="1" cols="1" sm="2" class="text-center titles">
                    <strong>Approved</strong>
                  </v-col>
                  <v-col class="rowItem" v-if="!weekItems.timesheets || weekItems.timesheets.length === 0" md="12" sm="12" cols="12">
                    <v-row>
                      <v-col xl="1" md="1" cols="1" sm="1" class="text-center datas"> ... </v-col>
                      <v-col md="1" cols="1" sm="1" class="text-center datas"> ... </v-col>
                      <v-col md="2" cols="2" sm="2" class="text-center datas"> ... </v-col>
                      <v-col md="1" cols="1" sm="1" class="text-center datas"> ... </v-col>
                      <v-col md="1" cols="1" sm="1" class="text-center datas"> ... </v-col>
                      <v-col xl="2" cols="2" sm="2" class="text-center datas"> ... </v-col>
                      <v-col md="1" cols="1" sm="1" class="text-center datas"> ... </v-col>
                      <v-col md="2" cols="2" sm="2" class="text-center datas"> ... </v-col>
                      <v-col md="1" cols="1" sm="1" class="text-center datas"> ... </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    v-else
                    v-bind:style="[
                      timesheetIndex % 2 === 0 || timesheetIndex === 0 ? { 'background-color': '#FFDBDB' } : { 'background-color': '#FFCCCC' },
                    ]"
                    class="rowItem"
                    md="12"
                    sm="12"
                    cols="12"
                    v-for="(timesheetItem, timesheetIndex) in weekItems.timesheets"
                    :key="'timesheet_' + timesheetIndex"
                  >
                    <v-row>
                      <v-col xl="1" md="1" cols="1" sm="1" class="text-center datas">
                        {{ formatDate(timesheetItem.Date) }}
                      </v-col>
                      <v-col md="1" cols="1" sm="1" class="text-center datas">
                        {{ timesheetItem.IssueNo }}
                      </v-col>
                      <v-col md="2" cols="2" sm="2" class="text-center datas">
                        {{ timesheetItem.Project?.Name }}
                      </v-col>
                      <v-col md="1" cols="1" sm="1" class="text-center vertical-center datas">
                        {{ timesheetItem.Epic }}
                      </v-col>
                      <v-col md="1" cols="1" sm="1" class="text-center datas">
                        {{ getActivityName(timesheetItem.ActivityId) }}
                      </v-col>
                      <v-col xl="2" md="2" cols="2" sm="2" class="text-center datas">
                        {{ getTechnologyName(timesheetItem.TechnologyId) }}
                      </v-col>
                      <v-col md="1" cols="1" sm="1" class="text-center datas">
                        {{ timesheetItem.Effort }}
                      </v-col>
                      <v-col cols="2" sm="2" md="2" class="text-center datas">
                        {{ timesheetItem.Project?.Name ? timesheetItem.Adjustment : "" }}
                      </v-col>
                      <v-col cols="1" sm="1" md="1" class="text-center datas">
                        <span v-if="timesheetItem.Project?.Name">
                          <v-icon v-if="timesheetItem.isLocked" color="success">mdi-lock</v-icon>
                          <v-icon v-else color="error">mdi-lock-open</v-icon>
                        </span>
                      </v-col>
                      <v-col sm="2" cols="2" md="2" class="text-center datas"> Description </v-col>
                      <v-col sm="10" cols="10" md="10" class="datas">
                        {{ timesheetItem.Description }}
                      </v-col>
                      <v-col v-if="timesheetItem.Commits != null && timesheetItem.Commits.length > 0">
                        <v-col md="2" class="text-center datas"> Commits </v-col>
                        <v-col md="12" class="datas" v-for="commit in timesheetItem.Commits" :key="commit.id">
                          Lines Added= <strong>{{ commit.linesAdded }} </strong>| Lines Modified= <strong>{{ commit.linesChanged }}</strong> | Lines
                          Deleted= <strong>{{ commit.linesDeleted }}</strong> | Description= <strong>{{ commit.messageShort }}</strong>
                          <span v-if="commit.date"
                            >| Date= <strong>{{ formatDate(commit.date) }}</strong></span
                          >
                        </v-col>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col class="weeklyTotal pl-10" md="12" sm="12">
                    <v-row>
                      <v-col md="3" sm="4" cols="4">
                        <strong> WEEK TOTAL HOURS: {{ removeDecimals(calculateHours(weekItems.timesheets)) }} </strong>
                      </v-col>
                      <v-col md="3" sm="4" cols="4">
                        <strong> WEEK TOTAL ADJUSTMENT: {{ removeDecimals(calculateAdjustment(weekItems.timesheets)) }} </strong>
                      </v-col>
                      <v-col md="3" sm="4" cols="4">
                        <strong> WEEK TOTAL BILLABLE: {{ removeDecimals(calculateBillable(weekItems.timesheets)) }} </strong>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="mt-5 mb-5">
              <v-col class="mt-2 weeklyTotal" md="12" sm="12" cols="12">
                <v-row>
                  <v-col md="4" sm="4" cols="12" class="text-center">
                    <strong>
                      TEAMMEMBER TOTAL HOURS: <span class="totalcalc">{{ removeDecimals(calculateTotalHours(listItem.weeklyReport)) }}</span>
                    </strong>
                  </v-col>
                  <v-col md="4" sm="4" cols="12" class="text-center">
                    <strong>
                      TEAMMEMBER TOTAL ADJUSTMENT:
                      <span class="totalcalc">{{ removeDecimals(calculateTotalAdjustment(listItem.weeklyReport)) }}</span>
                    </strong>
                  </v-col>
                  <v-col md="4" sm="4" cols="12" class="text-center">
                    <strong>
                      TEAMMEMBER TOTAL BILLABLE: <span class="totalcalc">{{ removeDecimals(calculateTotalBillable(listItem.weeklyReport)) }}</span>
                    </strong>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </div>
        <v-col v-if="teammemberReport && teammemberReport.length != 0" md="12" sm="12" cols="12">
          <v-row>
            <v-col class="mt-2 weeklyTotal" md="12" sm="12" cols="12">
              <v-row>
                <v-col md="4" sm="4" cols="12" class="text-center">
                  <strong>
                    GRAND TOTAL HOURS: <span class="totalcalc">{{ removeDecimals(grandTotalHour) }}</span>
                  </strong>
                </v-col>
                <v-col md="4" sm="4" cols="12" class="text-center">
                  <strong>
                    GRAND TOTAL ADJUSTMENT: <span class="totalcalc">{{ removeDecimals(grandTotalAdjustment) }}</span>
                  </strong>
                </v-col>
                <v-col md="4" sm="4" cols="12" class="text-center">
                  <strong>
                    GRAND TOTAL BILLABLE: <span class="totalcalc">{{ removeDecimals(grandTotalBillable) }}</span>
                  </strong>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </div>
    </v-card-text>
    <v-dialog v-model="git.connectionErrorDialogVisible" @keydown.esc="git.connectionErrorDialogVisible = false" persistent max-width="860">
      <v-card>
        <v-card-title>Connection Errors</v-card-title>
        <hr />
        <v-card-text class="pt-3 message-text">
          <p v-for="(item, index) in git.connectionErrors" :key="`git-err-${index}`" border="right" colored-border type="error" elevation="2">
            <span>
              -<b>{{ item.repositoryHttpsLink }}: </b></span
            >
            {{ item.errorMessage }}
          </p>
          <br />
        </v-card-text>
        <v-card-actions>
          <v-col md="12">
            <v-btn class="secondary" @click="git.connectionErrorDialogVisible = false"> <v-icon>mdi-close</v-icon> Close </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="resultLogVisible" @keydown.esc="resultLogVisible = false" persistent max-width="860">
      <v-card>
        <v-card-title>Log Result</v-card-title>
        <hr />
        <v-card-text class="pt-3 message-text">
          <p v-html="resultlogContent" />
        </v-card-text>
        <v-card-actions>
          <v-col md="12">
            <v-btn class="secondary" @click="resultLogVisible = false"> <v-icon>mdi-close</v-icon> Close </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="timesheet.timesheetsIssuesDialogVisible"
      @keydown.esc="timesheet.timesheetsIssuesDialogVisible = false"
      persistent
      max-width="860"
    >
      <v-card>
        <v-card-title>Timesheet Issues For {{ timesheet.selectedTeammemberName }}</v-card-title>
        <hr />
        <v-card-text class="pt-3 message-text">
          <p
            v-for="(item, index) in timesheet.selectedIssuesForTeammember"
            :key="`git-err-${index}`"
            border="right"
            colored-border
            type="warning"
            elevation="2"
            v-html="item"
          ></p>
        </v-card-text>
        <v-card-actions>
          <v-col md="12">
            <v-btn class="secondary" @click="timesheet.timesheetsIssuesDialogVisible = false"> <v-icon>mdi-close</v-icon> Close </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script lang="ts">
import Vue, { defineComponent } from "vue";
import Timesheet from "../../../models/Timesheet";
import ProjectLead from "../../../models/ProjectLead";
import RepositoryGitInsightRequest from "../../../viewModels/request/Repository/RepositoryGitInsightRequest";
import GitConnectionIssues from "../../../viewModels/response/repository/GitConnectionIssues";
import RepositoryTeammemberCommit from "../../../viewModels/response/repository/RepositoryTeammemberCommit";
import ActivityService from "../../../services/ActivityService";
import ProjectLeadService from "../../../services/ProjectLeadService";
import RepositoryService from "../../../services/RepositoryService";
import TeamMemberService from "../../../services/TeamMemberService";
import TechnologyService from "../../../services/TechnologyService";
import TimesheetReportService from "../../../services/TimesheetReportService";
import TimesheetService from "../../../services/TimesheetService";
import Utils from "../../../utils/Utils";
import { Technology } from "../../../models/Technology";
import { Activity } from "../../../models/Activity";
import SelectField from "../../../components/Fields/SelectField.vue";
import DateRangeInputField from "../../../components/Fields/DateRangeInputField.vue";

import moment from "moment";

interface TeammemberReport {
  teammemberName: string | null;
  weeklyReport: WeeklyReport[];
}
interface WeeklyReport {
  week: string;
  timesheets: Timesheet[];
}

interface TeammemberTimesheetIssues {
  teammemberName: string;
  teammemberId: string;
  issues: string[];
}

export default defineComponent({
  props: {
    isAdmin: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    SelectField,
    DateRangeInputField,
  },
  data() {
    return {
      resultLogVisible: false,
      resultlogContent: "",
      git: {
        connectionErrorDialogVisible: false,
        connectionErrors: [] as GitConnectionIssues[],
      },
      commit: {
        list: [] as RepositoryTeammemberCommit[],
        totalAdded: 0,
        totalModified: 0,
        totalDeleted: 0,
      },
      timesheet: {
        issues: [] as TeammemberTimesheetIssues[],
        selectedTeammemberId: "",
        selectedTeammemberName: "",
        selectedIssuesForTeammember: [] as string[],
        timesheetsIssuesDialogVisible: false,
      },
      projectLeads: [] as Array<{ id: string; text: string }>,
      teammembers: [] as Array<{ id: string; text: string }>,
      projectLeadObjects: [] as ProjectLead[],
      selectedTeammembers: [] as string[],
      timesheetReport: [] as Timesheet[],
      selectedProjectLead: null,
      dateRanges: ["This Week", "Last Week", "Last Month", "This Month", "Last Year", "This Year"],
      selectedDateRange: [],
      grandTotalHour: 0,
      grandTotalAdjustment: 0,
      grandTotalBillable: 0,
      teammemberReport: [] as TeammemberReport[],
      weeklyReport: [] as WeeklyReport[],
      datePickerMenu: false,
      isLoading: false,
      dateRangeDates: [],
      technologies: [] as Technology[],
      activities: [] as Activity[],
      headers: [
        { title: "Date", align: "start", value: "Date" },
        { title: "TICKET/ISSUE", value: "IssueNo" },
        { title: "Project", value: "Project" },
        { title: "Epic", value: "Epic" },
        { title: "Activity", value: "Activity" },
        { title: "Technology", value: "Technology" },
        { title: "Hours/Effort", value: "Effort" },
        { title: "Adjustment", value: "Adjustment" },
      ],
    };
  },
  computed: {
    showReport(): boolean {
      return this.teammemberReport && this.teammemberReport.length != 0;
    },
    dateRangeText(): string {
      const retVal = `${Utils.toVsDateFormat(this.selectedDateRange[0])} ~ ${Utils.toVsDateFormat(
        this.selectedDateRange[this.selectedDateRange.length - 1]
      )}`;
      if (this.selectedDateRange.length > 1) {
        this.datePickerMenu = false;
      }
      return retVal;
    },
    startDate(): string {
      return this.selectedDateRange[0];
    },
    endDate(): string {
      return this.selectedDateRange[this.selectedDateRange.length - 1];
    },
    allTeamMemberIds(): string[] {
      return this.teammembers.map(({ id }) => id);
    },
  },
  methods: {
    async syncAllRepositories() {
      try {
        this.isLoading = true;
        if (this.selectedProjectLead) {
          const result = await RepositoryService.fetchRepositoriesManuallyByProjectLeadId(this.selectedProjectLead);
          if (result) {
            this.resultlogContent = result.toString();
            this.resultLogVisible = true;
          }
        }
      } catch (error: any) {
        const errorMessage = error && error.response && error.response.data;
        this.showErrorMessage(errorMessage);
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }
    },
    showTimesheetIssuesForTeammember(teammemberId: string, teammemberName: string, selectedIssuesForTeammember: string[]) {
      this.timesheet.selectedIssuesForTeammember = selectedIssuesForTeammember;
      this.timesheet.selectedTeammemberId = teammemberId;
      this.timesheet.selectedTeammemberName = teammemberName;
      this.timesheet.timesheetsIssuesDialogVisible = true;
    },
    async syncCommitsForSelectedTeamMembers() {
      try {
        this.isLoading = true;
        const dates = this.dateRangeText.split("~");
        const tms = this.selectedTeammembers && this.selectedTeammembers.length ? this.selectedTeammembers : this.teammembers.map((x) => x.id);
        if (tms && tms.length) {
          await RepositoryService.syncCommitsOfTeamMembersManually(tms, dates[0], dates[1]);
        }
        this.createReport();
      } catch (error: any) {
        const errorMessage = error && error.response && error.response.data;
        this.showErrorMessage(errorMessage);
      } finally {
        this.isLoading = false;
      }
    },
    decimalCount(num: any) {
      const numStr = String(num);
      if (numStr.includes(".")) {
        return numStr.split(".")[1].length;
      }
      return 0;
    },
    removeDecimals(value: any) {
      if (this.decimalCount(value) > 2 && value !== 0) {
        return Number(value.toFixed(2));
      }
      return value;
    },
    async fetchTechnologies() {
      this.technologies = await TechnologyService.getTechnologyList();
    },
    getTechnologyName(technologyId: any) {
      if (technologyId) {
        const findTechnology = this.technologies.find((item) => item.id === technologyId);
        return findTechnology ? findTechnology.Value : "";
      }
      return "";
    },
    async fetchActivities() {
      this.activities = await ActivityService.getActivityList();
    },
    getActivityName(activityId: string | null): string {
      if (activityId) return this.activities.find((item) => item.id == activityId)?.Value ?? "";
      return "";
    },
    calculateTotalHours(list: any) {
      const timesheets = list.filter((c: any) => c.timesheets).map((item: any) => item.timesheets);
      list = [];
      if (timesheets) {
        timesheets.forEach((c: any) => {
          if (c) {
            list = list.concat(c);
          }
        });
      }
      return this.calculateHours(list);
    },
    calculateTotalAdjustment(list: any) {
      const timesheets = list.filter((c: any) => c.timesheets).map((item: any) => item.timesheets);
      list = [];
      if (timesheets) {
        timesheets.forEach((c: any) => {
          if (c) {
            list = list.concat(c);
          }
        });
      }
      return this.calculateAdjustment(list);
    },
    calculateTotalBillable(list: any) {
      const timesheets = list.filter((c: any) => c.timesheets).map((item: any) => item.timesheets);
      list = [];
      if (timesheets) {
        timesheets.forEach((c: any) => {
          if (c) {
            list = list.concat(c);
          }
        });
      }
      return this.calculateBillable(list);
    },
    calculateHours(list: Timesheet[]) {
      if (list && list.length > 0) {
        const timesheetList = list.filter((c) => c.ProjectId && (c.Activity || c.ActivityId) && c.Epic);
        if (timesheetList && timesheetList.length > 0) {
          let totalHours = timesheetList.map((item) => item.Effort).reduce((prev, next) => prev + next);
          totalHours = this.removeDecimals(totalHours);
          return totalHours;
        }
      }
      return 0;
    },
    calculateAdjustment(list: Timesheet[]) {
      if (list && list.length > 0) {
        const timesheetList = list.filter((c) => c.ProjectId && (c.Activity || c.ActivityId) && c.Epic);
        if (timesheetList && timesheetList.length > 0) {
          let totalAdjustment = timesheetList.map((item) => item.Adjustment).reduce((prev, next) => prev + next);
          totalAdjustment = this.removeDecimals(totalAdjustment);
          return totalAdjustment;
        }
      }
      return 0;
    },
    calculateBillable(list: Timesheet[]) {
      if (list && list.length > 0) {
        const timesheetList = list.filter((c) => c.ProjectId && (c.Activity || c.ActivityId) && c.Epic);
        if (timesheetList && timesheetList.length > 0) {
          let totalHours = timesheetList.map((item) => item.Effort).reduce((prev, next) => prev + next);
          let totalAdjustment = timesheetList.map((item) => item.Adjustment).reduce((prev, next) => prev + next);
          totalHours = this.removeDecimals(totalHours);
          totalAdjustment = this.removeDecimals(totalAdjustment);
          let totalBillable = totalHours + totalAdjustment;
          totalBillable = this.removeDecimals(totalBillable);
          return totalBillable;
        }
      }
      return 0;
    },
    async download() {
      this.isLoading = true;
      TimesheetReportService.getFile(this.teammemberReport).then((resp) => {
        const result = resp as Blob;
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Report.html");
        document.body.appendChild(link);
        link.click();
        this.isLoading = false;
      });
    },
    async sendEmail() {
      this.isLoading = true;
      const projectLead = this.projectLeadObjects.find((c) => c.id === this.selectedProjectLead);
      if (projectLead) {
        await TimesheetReportService.send(this.teammemberReport, projectLead.Email);
      }
      this.isLoading = false;
    },
    formatDate(date: Date | null): string {
      if (date) {
        return Utils.toVsDateFormat(date);
      } else {
        return "Not set";
      }
    },
    clearFilters() {
      this.selectedProjectLead = null;
      this.selectedTeammembers = [];
    },
    async createReport() {
      if (this.selectedDateRange.length < 2) {
        return;
      }
      if (this.selectedProjectLead) {
        this.isLoading = true;
        const dates = this.dateRangeText.split("~");
        await this.fetchTimesheetReport(Utils.vsDateToDatetime(dates[0]), Utils.vsDateToDatetime(dates[1]));
        this.grandTotalBillable = this.removeDecimals(this.grandTotalHour + this.grandTotalAdjustment);
        this.isLoading = false;
      }
    },
    async fetchProjectLead() {
      this.projectLeadObjects = await ProjectLeadService.getList(true);
      this.projectLeads = this.projectLeadObjects
        .filter((c) => (c.FirstName && c.FirstName.trim()) || (c.LastName && c.LastName.trim()))
        .map((item) => {
          return { id: item.id, text: `${item.FirstName} ${item.LastName}` };
        });
    },
    async fetchTeammembers(prLeadId: any) {
      const list = await TeamMemberService.getByProjectLeadId(prLeadId);
      this.teammembers = list
        .filter((c) => c.TmFullName)
        .map((item) => {
          return { id: item.id, text: item.TmFullName };
        });
    },
    getDatesBetweenDates(startDate: any, endDate: any) {
      let dates = [] as Date[];
      const theDate = new Date(startDate);
      while (theDate < endDate) {
        dates = [...dates, new Date(theDate)];
        theDate.setDate(theDate.getDate() + 1);
      }
      dates = [...dates, endDate];
      return dates;
    },
    getStartandEndOfWeek(date: any) {
      const startOfWeek = moment(date).startOf("week").toDate();
      const endOfWeek = moment(date).endOf("week").toDate();
      const firstday = Utils.toVsDateFormat(startOfWeek);
      const lastday = Utils.toVsDateFormat(endOfWeek);
      return `${firstday} ~ ${lastday}`;
    },
    getTeammemberCommits(teammemberId: any) {
      return this.commit.list.filter((cm: any) => cm.TeamMemberId === teammemberId);
    },
    getTeammemberTimesheets(teammemberId: any) {
      return this.timesheetReport.filter((tr: any) => tr.TeamMemberId === teammemberId);
    },
    getTeammemberTimesheetInWeek(teammemberId: any) {
      const timesheetsInWeek = [] as WeeklyReport[];
      this.weeklyReport.forEach((wr: any) => {
        const splitedDate = wr.week.split("~");
        const weekSDate = Utils.toVsDateFormat(splitedDate[0].trim());
        const weekEDate = Utils.toVsDateFormat(splitedDate[1].trim());
        const selectedSDate = Utils.toVsDateFormat(this.selectedDateRange[0]);
        const selectedEDate = Utils.toVsDateFormat(this.selectedDateRange[this.selectedDateRange.length - 1]);
        const timesheetList = this.getTeammemberTimesheets(teammemberId).filter(
          (tr) =>
            Utils.toVsDateFormat(tr.Date) &&
            Utils.toVsDateFormat(tr.Date) >= weekSDate &&
            Utils.toVsDateFormat(tr.Date) <= weekEDate &&
            Utils.toVsDateFormat(tr.Date) >= selectedSDate &&
            Utils.toVsDateFormat(tr.Date) <= selectedEDate
        );

        timesheetList.forEach((c) => {
          c.Date = Utils.addTimezoneOffset(c.Date);
          c.Effort = this.removeDecimals(c.Effort);
          if (c.ProjectId && (c.Activity || c.ActivityId) && c.Epic) {
            this.grandTotalHour += this.removeDecimals(c.Effort);
            this.grandTotalAdjustment += this.removeDecimals(c.Adjustment);
          }
        });
        timesheetsInWeek.push({ week: wr.week, timesheets: timesheetList });
      });
      return timesheetsInWeek;
    },
    async fetchTimesheetReport(startDate: Date, endDate: Date) {
      this.grandTotalHour = 0;
      this.grandTotalAdjustment = 0;
      this.grandTotalBillable = 0;
      let uniqueTeammemberIds;
      this.weeklyReport = [];
      this.teammemberReport = [];
      const yearStep = [] as Array<{
        Step: number;
        Year: number;
      }>;
      this.timesheetReport = await TimesheetReportService.getList(startDate, endDate, this.selectedProjectLead);

      // set git connection errors
      await this.setGitConnectionErrorsForProjectLead();

      // set commits for project lead
      await this.setCommitListByProjectLead();
      this.timesheet.issues = [];
      if (this.timesheetReport && this.timesheetReport.length > 0) {
        const dates = this.dateRangeText.split("~");
        const sDate = Utils.vsDateToDatetime(dates[0]);
        const eDate = Utils.vsDateToDatetime(dates[1]);
        if (this.timesheetReport && this.timesheetReport.length > 0) {
          if (this.selectedTeammembers && this.selectedTeammembers.length > 0) {
            this.timesheetReport = this.timesheetReport.filter((c) => c.TeamMemberId && this.selectedTeammembers.includes(c.TeamMemberId));
          }
          const selectedTimesheetTeammembers = this.timesheetReport.map((tr) => tr.TeamMemberId);
          uniqueTeammemberIds = [...new Set(selectedTimesheetTeammembers)];
        }
        const datesArray = this.getDatesBetweenDates(sDate, eDate);
        datesArray.forEach((da) => {
          const weekDates = this.getStartandEndOfWeek(da);

          const exist = this.weeklyReport.some((wr) => wr.week === weekDates);
          if (!exist) {
            this.weeklyReport.push({ week: weekDates, timesheets: [] });
          }
        });
        if (uniqueTeammemberIds && uniqueTeammemberIds.length > 0) {
          uniqueTeammemberIds.forEach((ut: any) => {
            const teammember = this.teammembers.find((x) => x.id == ut);
            const teammemberName = teammember ? teammember.text : "";

            this.timesheet.issues.push({
              issues: TimesheetService.TimesheetReviewResultForTeammember(this.getTeammemberTimesheets(ut), this.getTeammemberCommits(ut)),
              teammemberId: ut,
              teammemberName: teammemberName,
            });
            this.teammemberReport.push({
              teammemberName: teammemberName,
              weeklyReport: this.getTeammemberTimesheetInWeek(ut),
            });
          });
        }
      } else {
        this.showErrorMessage("No data!");
      }
    },
    showErrorMessage(errorMessage: any) {
      this.$emit("errorRaised", errorMessage);
    },
    async setGitConnectionErrorsForProjectLead() {
      try {
        this.isLoading = true;
        const dates = this.dateRangeText.split("~");
        const model = {
          EndDate: Utils.vsDateToDatetime(dates[1]),
          StartDate: Utils.vsDateToDatetime(dates[0]),
          TeammemberIds: this.allTeamMemberIds,
        } as RepositoryGitInsightRequest;

        const projectLeadId = this.selectedProjectLead as string | null;
        if (projectLeadId) {
          this.git.connectionErrors = await RepositoryService.GitConnectionErrorsForProjectLead(projectLeadId, model);
        }
      } catch (error: any) {
        const errorMessage = error && error.response && error.response.data;
        this.showErrorMessage(errorMessage);
      } finally {
        this.isLoading = false;
      }
    },
    async setCommitListByProjectLead() {
      try {
        this.isLoading = true;
        this.commit.list = [];
        const dates = this.dateRangeText.split("~");
        const model = {
          EndDate: Utils.vsDateToDatetime(dates[1]),
          StartDate: Utils.vsDateToDatetime(dates[0]),
          TeammemberIds: this.allTeamMemberIds,
        } as RepositoryGitInsightRequest;
        const projectLeadId = this.selectedProjectLead as string | null;
        if (projectLeadId) {
          this.commit.list = await RepositoryService.GetCommitListByProjectLead(projectLeadId, model);
          let totalAdded = 0;
          let totalModified = 0;
          let totalDeleted = 0;
          if (this.commit.list) {
            this.commit.list.forEach((commit) => {
              totalAdded += commit.linesAdded;
              totalModified += commit.linesChanged;
              totalDeleted += commit.linesDeleted;
            });
          }

          this.commit.totalAdded = totalAdded;
          this.commit.totalModified = totalModified;
          this.commit.totalDeleted = totalDeleted;
        }
      } catch (error: any) {
        const errorMessage = error && error.response && error.response.data;
        this.showErrorMessage(errorMessage);
      } finally {
        this.isLoading = false;
      }
    },
    selectedRange(newVal: string) {
      let startDate = new Date();
      let endDate = new Date();
      switch (newVal) {
        case "This Week":
          startDate = moment().startOf("week").toDate();
          endDate = moment().endOf("week").toDate();
          break;
        case "Last Week":
          startDate = moment().subtract(1, "weeks").startOf("week").toDate();
          endDate = moment().subtract(1, "weeks").endOf("week").toDate();
          break;
        case "Last Month":
          startDate = moment().subtract(1, "months").startOf("month").toDate();
          endDate = moment().subtract(1, "months").endOf("month").toDate();
          break;
        case "This Month":
          startDate = moment().startOf("month").toDate();
          endDate = moment().endOf("month").toDate();
          break;
        case "Last Year":
          startDate = moment().subtract(1, "years").startOf("year").toDate();
          endDate = moment().subtract(1, "years").endOf("year").toDate();
          break;
        case "This Year":
          startDate = moment().startOf("year").toDate();
          endDate = moment().endOf("year").toDate();
          break;
      }
      if (startDate < endDate) {
        (this.selectedDateRange as any) = [startDate, endDate];
      }
    },
  },
  watch: {
    selectedProjectLead(newVal) {
      this.selectedTeammembers = [];
      this.fetchTeammembers(newVal);
    },
  },
  async mounted() {
    this.selectedRange("This Week");
    await this.fetchTechnologies();
    await this.fetchActivities();
    await this.fetchProjectLead();
  },
});
</script>
<style scoped lang="scss">
@import "node_modules/shared-components/assets/colors.scss";
@import "node_modules/shared-components/assets/sizes.scss";

.timesheetreport-body {
  overflow-x: scroll;
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: scroll;
}
.timesheetreport-body::-webkit-scrollbar {
  display: none; /* for Chrome, Safari, and Opera */
}
.report-content {
  min-height: 300px;
}
.timesheetreport-item {
  min-width: 973px;
}
.rowItem {
  background-color: $light_pink;
}
.desc {
  background-color: $pink;
}
.totalcalc {
  color: $primary;
}
.weeklyTotal {
  background-color: $pit_crew_uniform;
  color: $primary;
}
.datas {
  border: 1px solid $primary;
  color: $text_color;
}
.header {
  background-color: $pit_crew_uniform;
  border: 1px solid $pit_crew_uniform;
  color: $primary;
}
.titles {
  background-color: $racecar;
  border: 1px solid $primary;
  color: $primary;
}
.hours {
  border: 3px solid $text_color;
}
.month {
  border: 3px solid $pit_crew_uniform;
}
.action-field {
  height: 55px;
}
@media (max-width: 600px) {
  .action-button {
    width: 100%;
  }
}
@media (max-width: 368px) {
  .weeklyTotal {
    font-size: $size-xs;
  }
}
</style>
